import { render, staticRenderFns } from "./ChatEventsBar.vue?vue&type=template&id=afa79a42"
import script from "./ChatEventsBar.vue?vue&type=script&lang=js"
export * from "./ChatEventsBar.vue?vue&type=script&lang=js"
import style0 from "./ChatEventsBar.vue?vue&type=style&index=0&id=afa79a42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports